// extracted by mini-css-extract-plugin
export default {"root":"ConsignmentStatusChip_root__dhd0C"};